export const buildRedirectParam = (targetPath) => {
  if (!targetPath) return ''
  const raw = String(targetPath)
  const withoutProto = raw.replace(/^https?:\/\/[^/]+/, '')
  const normalized = '/' + withoutProto.replace(/^\/+/, '')
  return encodeURIComponent(normalized)
}
